import React, { useState, useEffect } from 'react';

export const BrandModal = ({ show, onClose, onSubmit, isEdit, currentItem }) => {
    const [formData, setFormData] = useState({ name: '', imageFile: null });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (isEdit && currentItem) {
            setFormData({ name: currentItem.name, imageFile: null });
        } else {
            setFormData({ name: '', imageFile: null });
        }
    }, [isEdit, currentItem]);

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Required';
        if (!isEdit && !formData.imageFile) newErrors.image = 'Required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            const submitData = new FormData();
            submitData.append('name', formData.name);
            if (formData.imageFile) {
                submitData.append('image', formData.imageFile);
            }
            if (isEdit && currentItem) {
                submitData.append('id', currentItem.id);
            }
            onSubmit(submitData);
        }
    };

    const handleNameChange = (e) => {
        setFormData({ ...formData, name: e.target.value });
    };

    const handleImageChange = (e) => {
        setFormData({ ...formData, imageFile: e.target.files[0] });
    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-3 sm:p-4">
            <div className="bg-white p-4 sm:p-6 rounded-lg max-w-sm sm:max-w-md w-full max-h-[90vh] overflow-y-auto">
                <h2 className="text-lg sm:text-xl font-bold mb-4">{isEdit ? 'Edit Brand' : 'Add Brand'}</h2>
                <form onSubmit={handleSubmit}>
                    <input name="name" value={formData.name} onChange={handleNameChange} placeholder="Name" className="w-full p-2.5 sm:p-3 border rounded mb-2 text-sm sm:text-base" />
                    {errors.name && <p className="text-red-500 text-xs sm:text-sm mb-2">{errors.name}</p>}

                    {isEdit && currentItem.image && (
                        <div className="mb-3">
                            <label className="block text-sm font-medium mb-1">Current Image</label>
                            <img src={currentItem.image} alt="Current Brand" className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded mb-2" />
                        </div>
                    )}

                    <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">New Image (optional for edit)</label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            className="w-full p-2 border rounded text-sm"
                        />
                        {(!isEdit && errors.image) && <p className="text-red-500 text-xs sm:text-sm mt-1">{errors.image}</p>}
                    </div>

                    <div className="flex flex-col-reverse sm:flex-row justify-end gap-2 sm:space-x-2">
                        <button type="button" onClick={onClose} className="px-4 py-2.5 bg-gray-300 hover:bg-gray-400 rounded text-sm sm:text-base w-full sm:w-auto">Cancel</button>
                        <button type="submit" className="px-4 py-2.5 bg-blue-500 hover:bg-blue-600 text-white rounded text-sm sm:text-base w-full sm:w-auto">{isEdit ? 'Update' : 'Add'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};